/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droppublished1Inputs */

const en_droppublished1 = /** @type {(inputs: Droppublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop published`)
};

const de_droppublished1 = /** @type {(inputs: Droppublished1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Drop published" |
*
* @param {Droppublished1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droppublished1 = /** @type {((inputs?: Droppublished1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droppublished1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droppublished1(inputs)
	return de_droppublished1(inputs)
});
export { droppublished1 as "dropPublished" }